<template>
  <div class="flex flex-col items-center">
    <div class="w-full space-y-2 xl:w-1/2">
      <a-button :to="{ name: 'payments' }">
        Regresar
      </a-button>
<!--      @submit.prevent="testingisUpdating ? update(payment) : store({ ...payment, ...payment.amount * 100 })"-->

      <template>
          <h3 class="my-4 text-2xl">
            {{ isUpdating ? 'Actualizar' : 'Registrar' }} pago
          </h3>
          <div class="flex flex-col" style="height: 470px;">
            <template v-if="loadings.data">
              <div class="flex items-center justify-center h-full">
                <a-loader class="h-12 w-12 mt-4 text-primary"/>
              </div>
            </template>
            <template v-else-if="paymentStep === 1">
              <h3 class="text-xl">
                Por favor, seleccione un estudiante
              </h3>
              <a-select
                v-if="!isUpdating"
                label="Período"
                class="mb-4"
                required
                :source="periods.map(el => ({ label: `${el.year}-${el.number}`, value: el.id }))"
                :error="error('period_id')"
                :loading="loadingPeriods"
                v-model="payment.period_id" />

              <a-select
                v-if="!isUpdating"
                :disabled="loadingStudents || !payment.period_id"
                :source="students.map(el => ({ label: `${el.first_name} ${el.last_name}`, value: el.id }))"
                :error="error('student_id')"
                class="mb-4"
                required
                label="Estudiante"
                :loading="loadingStudents"
                v-model="payment.student_id"/>
            </template>
            <template v-else-if="paymentStep === 2">
              <span v-if="isUpdating" class="my-4 text-xl font-bold">
                {{ payment.student.last_name }}, {{ payment.student.first_name }}
              </span>
              <span v-else class="my-4 text-xl font-bold">
                {{ getStudentName }}
              </span>
              <template v-if="loadings.loadingPeriodFee">
                <div class="flex items-center justify-center h-full">
                  <a-loader class="h-12 w-12 mt-4 text-primary"/>
                </div>
              </template>
              <template v-else-if="!periodFee">
                <div class="flex items-center justify-center h-full">
                  <span class="text-gray-500">No se encontraron cuotas para el estudiante seleccionado</span>
                </div>
              </template>
              <template v-else>
                <template v-if="validateFirstPayment() || validateFullPayment()">
                  <div class="space-y-4 p-2" style="max-height: 400px; overflow-y: auto;">
                    <template v-if="isUpdating">
                      <div class="flex w-full">
                        <label class="font-medium block">
                          {{ validateFirstPayment() ? 'Este pago corresponde al monto inicial de inscripción' : 'Este pago cubre el monto inicial de inscripción y el monto total de las cuotas' }}
                        </label>
                      </div>
                    </template>
                    <template v-else>
                      <div class="flex w-full">
                        <label class="font-medium block">
                          Este pago servirá para la inscripción de {{ getStudentName }}
                        </label>
                      </div>
                      <div class="flex w-full">
                        <label class="font-medium block">
                          Forma de pago
                        </label>
                        <span class="text-red-600 inline-block ml-1 font-bold">
                          *
                        </span>
                      </div>
                      <div class="flex flex-row space-x-4 w-full my-2">
                        <label class="inline-flex items-center">
                          <input type="radio" 
                            id="installment" 
                            value="installment"
                            v-model="paymentOption"
                            class="form-radio h-4 w-4 text-blue-600">
                          <span class="ml-2">Pagar sólo inicial</span>
                        </label>
                        <label class="inline-flex items-center">
                          <input type="radio" 
                            id="fully" 
                            value="fully"
                            v-model="paymentOption"
                            class="form-radio h-4 w-4 text-blue-600">
                          <span class="ml-2">Pagar por completo</span>
                        </label>
                      </div>
                      <template v-if="periodFee && paymentOption === 'installment'">
                        <h3 class="my-2 font-bold">Resumen de pago:</h3>
                        <div class=" bg-gray-200 p-3 rounded my-2">
                          <div class="flex items-center justify-between my-2">
                            <span>Total:</span> 
                            <b>
                              ${{ periodFee.initial_price }}
                            </b>
                          </div>
                        </div>
                      </template>
                      <template v-if="periodFee && paymentOption === 'fully'">
                        <h3 class="my-2 font-bold">Resumen de pago:</h3>
                        <div class=" bg-gray-200 p-3 rounded my-2">
                          <div class="flex items-center justify-between my-2">
                            <span>Costo inicial:</span> 
                            <b>
                              ${{ periodFee.initial_price }}
                            </b>
                          </div>
                          <div class="flex items-center justify-between my-2">
                            <span>Costo por cuota:</span> 
                            <b>
                              ${{ periodFee.installments_price }}
                            </b>
                          </div>
                          <div class="flex items-center justify-between my-2">
                            <span>Cantidad de cuotas:</span> 
                            <b>
                              {{ periodFee.installments }}
                            </b>
                          </div>
                          <hr class="my-2 h-px border-t-0 bg-gray-500" />
                          <div class="flex items-center justify-between my-2">
                            <span>Total:</span> 
                            <b>
                              ${{ (periodFee.installments_price * periodFee.installments) + periodFee.initial_price }}
                            </b>
                          </div>
                        </div>
                      </template>
                    </template>
                    <a-select
                        :source="(isUpdating && (validateFirstPayment() || validateFullPayment())) ? [
                          {label: 'Efectivo', value: '1'},
                          {label: 'Transferencia bancaria', value: '3'},
                          {label: 'Zelle', value: '5'}
                        ] : getPaymentMethods"
                        label="Tipo de pago"
                        required
                        class="mb-4"
                        :error="error('type', { attribute: 'tipo de pago' })"
                        v-model="payment.type"/>
              
                    <a-input
                      label="Fecha"
                      class="mb-4"
                      required
                      id="date"
                      type="date"
                      :error="error('date')"
                      v-model="payment.date" />
              
                    <template v-if="isUpdating">
                      <a-input
                        label="Monto"
                        disabled
                        class="mb-4"
                        id="amount"
                        type="number"
                        :error="error('amount')"
                        v-model.number="payment.amount" />
                    </template>
                      <a-input
                      :required="payment.type !== '1'"
                      :disabled="payment.type === '1'"
                      label="Número de recibo"
                      class="mb-4"
                      id="receipt_number"
                      :error="error('receipt_number')"
                      v-model="payment.receipt_number" />
                  </div>
                </template>
                <template v-else>
                  <div class="space-y-4 p-2" style="max-height: 400px; overflow-y: auto;">
                    <div class="flex w-full">
                      <label class="font-medium block">
                        Forma de pago
                      </label>
                      <span class="text-red-600 inline-block ml-1 font-bold">
                        *
                      </span>
                    </div>
                    <div class="flex flex-row space-x-4 w-full my-2">
                      <label class="inline-flex items-center">
                        <input type="radio" 
                          id="installment" 
                          value="installment"
                          v-model="paymentOption"
                          class="form-radio h-4 w-4 text-blue-600">
                        <span class="ml-2">Pagar por cuota</span>
                      </label>
                      <label class="inline-flex items-center">
                        <input type="radio" 
                          id="fully" 
                          value="fully"
                          v-model="paymentOption"
                          class="form-radio h-4 w-4 text-blue-600">
                        <span class="ml-2">Pagar por completo</span>
                      </label>
                    </div>
                    <template v-if="paymentOption === 'installment'">
                      <div class=" bg-gray-200 p-3 rounded my-2">
                        <div class="flex items-center justify-between my-2">
                          <span>Costo de la siguiente cuota:</span> 
                          <b>
                            ${{ missingPaymentAmount / 100 }}
                          </b>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class=" bg-gray-200 p-3 rounded my-2">
                        <div class="max-h-32 overflow-y-auto">
                          <template
                            v-for="(installment, index) in getUnpaidFeeInstallments(periodFee.fee_installments)"
                          >
                            <div :key="index" class="flex items-center justify-between my-2">
                              <span>Costo {{ index + 1 }}° cuota:</span> 
                              <b>
                                ${{ getMissingInstallmentsTotal(installment) / 100 }}
                              </b>
                            </div>
                          </template>
                        </div>
                        <hr class="my-2 h-px border-t-0 bg-gray-500" />
                        <div class="flex items-center justify-between my-2">
                          <span>Costo total:</span> 
                          <b>
                            ${{ missingTotalPaymentAmount / 100 }}
                          </b>
                        </div>
                      </div>
                    </template>
                    <a-select
                        :source="getPaymentMethods"
                        label="Tipo de pago"
                        required
                        class="mb-4"
                        :error="error('type', { attribute: 'tipo de pago' })"
                        v-model="payment.type"/>
              
                    <a-input
                      label="Fecha"
                      class="mb-4"
                      required
                      id="date"
                      type="date"
                      :error="error('date')"
                      v-model="payment.date" />
              
                    <a-input
                      label="Monto"
                      :required="paymentOption === 'installment'"
                      :disabled="paymentOption === 'fully'"
                      class="mb-4"
                      id="amount"
                      type="number"
                      :error="error('amount')"
                      v-model.number="payment.amount" />
  
                      <a-input
                      :required="payment.type !== '1'"
                      :disabled="payment.type === '1'"
                      label="Número de recibo"
                      class="mb-4"
                      id="receipt_number"
                      :error="error('receipt_number')"
                      v-model="payment.receipt_number" />
                  </div>
                </template>
              </template>
            </template>
            <template v-else>
              <span class="my-4 text-xl font-bold">Resumen de pago</span>
              <div class="space-y-4 p-2" style="max-height: 400px; overflow-y: auto;">
                <div class="flex flex-col gap-4">
                  <div
                    v-for="(installment, index) in periodFee.fee_installments"
                    :key="index"
                    :class="[
                      'rounded-lg p-5 border-solid content-center h-24 bg-white border-l-4',
                      installment.paid_amount_e2 < installment.amount_e2 
                        ? isEnabled(installment.id)
                          ? 'border-red-400 shadow-lg'
                          : 'bg-gray-100 border-gray-30'
                        : 'border-primary shadow-lg bg-gray-100'
                    ]"
                  >
                    <div class="flex justify-between items-center">
                      <div class="flex flex-col gap-1">
                        <div class="flex items-center gap-2">
                          <a-icon name="calendar" />
                          <span class="text-gray-700 font-medium">
                            {{ moment(installment.date).locale('es').format('D [de] MMMM') }}
                          </span>
                        </div>
                        <template v-if="installment.is_late">
                          <span class="text-red-500 text-xs">
                            La cuota está atrasada, por lo que se le cobrará un extra de {{ installment.late_extra_amount_string }}
                          </span>
                        </template>
                        <template v-else-if="getDaysUntilLateFee(installment).isAfter">
                          <span class="text-yellow-400 text-xs">
                            Te quedan {{ getDaysUntilLateFee(installment).days }} días para pagar o tendrás que abonar {{ installment.late_extra_amount_string }} extra
                          </span>
                        </template>
                      </div>
                      <div class="flex flex-col items-end gap-2 relative">
                        <div class="flex items-center gap-2">
                          <template v-if="selectedInstallments[index] && selectedInstallments[index].paid_amount_e2 >= selectedInstallments[index].amount_e2">
                            <div class="rounded-full border-2 border-primary w-6 h-6 flex items-center justify-center bg-primary">
                              <a-icon name="check" class="text-white" stroke-width="2" />
                            </div>
                          </template>
                          <template v-else-if="selectedInstallments[index] && selectedInstallments[index].paid_amount_e2 > 0">
                            <div class="rounded-full border-2 border-yellow-400 bg-yellow-400 w-6 h-6 flex items-center justify-center">
                              <a-icon name="minus" class="text-white" stroke-width="2" />
                            </div>
                          </template>
                          <span class="text-gray-700 font-medium">
                            {{ getInstallmentAmount(index) }}
                          </span>
                        </div>
                        <div 
                          v-if="selectedInstallments[index]" 
                          class="text-xs w-full flex flex-col gap-1" 
                        >
                          <template v-if="selectedInstallments[index].is_new">
                            <div class="flex items-center justify-between w-40">
                              <span class="font-bold">Monto abonado:</span> 
                              <span>{{ (selectedInstallments[index].paid_amount_e2 / 100) }}$</span>
                            </div>
                            <template v-if="selectedInstallments[index].paid_amount_e2 < selectedInstallments[index].amount_e2">
                              <div class="flex items-center justify-between w-40">
                                <span class="font-bold text-red-500">Restante:</span> 
                                <span>{{ (selectedInstallments[index].amount_e2 - selectedInstallments[index].paid_amount_e2) / 100 }}$</span>
                              </div>
                            </template>
                          </template>
                          <template v-else-if="selectedInstallments[index].paid_amount_e2 >= selectedInstallments[index].amount_e2">
                            <a-badge class="bg-primary text-white">
                              Aprobado
                            </a-badge>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        <!-- <a-select
            :source="[
            { label: 'Efectivo', value: 1 },
            { label: '100% Banco', value: 2 },
            { label: 'Transferencia Bancaria', value: 3 },
            { label: 'Transferencia de Curso', value: 4 },
            { label: 'Zelle', value: 5 },
          ]"
            label="Tipo de pago"
            required
            class="mb-4"
            :error="error('type', { attribute: 'tipo de pago' })"
            v-model="payment.type"/>

        <a-input
            :disabled="payment.type === 1"
            :required="payment.type !== 1"
            label="Factura"
            class="mb-4"
            id="receipt_number"
            :error="error('receipt_number')"
            v-model="payment.receipt_number" />

        <a-input
          label="Fecha"
          class="mb-4"
          required
          id="date"
          type="date"
          :error="error('date')"
          v-model="payment.date" />

        <a-input
          label="Monto (USD)"
          required
          class="mb-4"
          id="amount"
          type="number"
          :error="error('amount')"
          v-model.number="payment.amount" /> -->
          
       

        

        <div class="flex justify-between">
          <a-button outlined :to="{ name: 'payments' }">
            Cancelar
          </a-button>
          <div class="flex justify-end space-x-2">
            <a-button v-if="souldBackButtonAppear" outlined @click="paymentStep -= 1">
              Anterior
            </a-button>
            <a-button 
              mode="primary" 
              :loading="loading"
              :disabled="shouldConfirmButtonDisabled()"
              @click="handleNextStep()"
            >
              {{ paymentStep === 1 || (paymentStep === 2 && !validateFirstPayment() && !validateFullPayment())
              ? 'Siguiente' 
              : isUpdating 
              ? 'Actualizar cambios' 
              : 'Reportar pago' }}
            </a-button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import moment from 'moment';

export default {
  data: () => ({
    payment: {
      date: null,
      receipt_number: null,
      amount: null, // este valor se guarda en centimos. 500000 => 500.00
      type: null,   // ver tipos de pago mas abajo
      student_id: null, // pertenece a un estudiante
      period_id: null,  // creado en un periodo
    },
    prevPayment: {
      date: null,
      receipt_number: null,
      amount: null, // este valor se guarda en centimos. 500000 => 500.00
      type: null,   // ver tipos de pago mas abajo
      student_id: null, // pertenece a un estudiante
      period_id: null,  // creado en un periodo
    },
    paymentStep: 1,
    isUpdating: false,
    loadings: {
      sendingPayment: false,
      loadingStudents: false,
      data: false
    },
    paymentOption: 'installment',
    selectedInstallments: [],
    studentData: null,
    paymentMethods: [
      { label: 'Efectivo', value: "1" },
      { label: '100% Banco', value: "2" },
      { label: 'Transferencia Bancaria', value: "3" },
      { label: 'Transferencia de Curso', value: "4" },
      { label: 'Zelle', value: "5" },
    ],
  }),
  computed: {
    ...mapGetters({
      hasError: 'hasError',
      error: 'error'
    }),
    ...mapState({
      payments: state => state.payments.pagination.data,
      paymentState: state => state.payments.current,
      currentPaymentOnState: state => state.payments.course,
      loading: state => state.payments.loading,
      periods: state => state.periods.all,
      students: state => state.students.all,
      loadingPeriods: state => state.periods.loading,
      loadingStudents: state => state.students.loading,
    }),
    getStudentName() {
      if(!this.payment.student_id) return null;
      const student = this.students.find(el => el.id === this.payment.student_id)
      if(!student) return null;
      return `${student.first_name} ${student.last_name}`
    },
    getPaymentMethods () {
      if(this.periodFee?.installment_payment_methods || this.periodFee?.full_payment_methods){
        if(this.paymentOption === "installment"){
          return this.paymentMethods.filter($0 => this.periodFee.installment_payment_methods.includes($0.value)) ?? [];
        }
        return this.paymentMethods.filter($0 => this.periodFee.full_payment_methods.includes($0.value)) ?? [];
      } return [];
    },
    missingPaymentAmount() {
      if(this.periodFee?.fee_installments){
        const filteredUnpaidInstallemnts = this.periodFee.fee_installments
          .filter(installment => installment.paid_amount_e2 < installment.amount_e2);

        if(filteredUnpaidInstallemnts.length > 0){
          const nextInstallment = filteredUnpaidInstallemnts[0];
          const amountPaid = nextInstallment.paid_amount_e2;
          const amountToPay = nextInstallment.is_late 
            ? nextInstallment.amount_e2 + nextInstallment.late_extra_amount_e2 - amountPaid 
            : nextInstallment.amount_e2 - amountPaid;
          return amountToPay;
        }
      } return 0;
    },
    missingTotalPaymentAmount () {
      if(this.periodFee?.fee_installments){
        const reducedTotalAmount = this.periodFee.fee_installments
          .filter(installment => installment.paid_amount_e2 < installment.amount_e2)
          .reduce((acc, installment) => {
            const amountPaid = installment.paid_amount_e2;
            const amountToPay = installment.is_late 
              ? installment.amount_e2 + installment.late_extra_amount_e2 - amountPaid 
              : installment.amount_e2 - amountPaid;
            acc += amountToPay;
            return acc;
          }, 0);
        return reducedTotalAmount;
      } return 0;
    },
    souldBackButtonAppear(){
      if(this.paymentStep === 1){
        return false;
      }
      if(this.isUpdating && this.paymentStep === 2){
        return false;
      }
      return true;
    }
  },
  methods: {
    ...mapMutations({
      setNavbarTitle: 'SET_NAVBAR_TITLE'
    }),
    ...mapActions({
      fetchCourse: 'payments/fetch',
      fetchPeriods: 'periods/index',
      fetchStudents: 'students/index',
      store: 'payments/store',
      update: 'payments/update',
      removeError: 'removeError',
    }),
    moment,
    handleNextStep(){
      if(this.paymentStep === 1){
        this.loadings.loadingStudents = true;
        this.$repository.students
        .getStudentPeriodFee(this.payment.student_id)
        .then(({ data }) => {
          this.periodFee = data;
          this.loadings.loadingStudents = false;
          this.paymentStep += 1;
        })
        .catch(() => {
          this.periodFee = null;
          this.loadings.loadingStudents = false;
          this.$message.error({
            message: 'El estudiante no posee una configuración de pago asociada al periodo actual'
          });
        });
      } else if(this.paymentStep === 2){
        if(!this.periodFee) return;
        if(this.validateFirstPayment() || this.validateFullPayment()){
          this.storePayment()
        } else {
          const filteredInstallments = this.periodFee.fee_installments.filter(installment => installment.paid_amount_e2 >= installment.amount_e2);
          this.selectedInstallments = filteredInstallments;
          
          if(this.paymentOption === "installment"){
            let totalAmount = this.payment.amount * 100;
            this.periodFee.fee_installments
              .filter(instalment => instalment.paid_amount_e2 < instalment.amount_e2)
              .forEach(installment => {
                const amountPaid = installment.paid_amount_e2;
                const amountToPay = installment.is_late
                  ? installment.amount_e2 + installment.late_extra_amount_e2 - amountPaid 
                  : installment.amount_e2 - amountPaid;
                  if (amountToPay > 0 && totalAmount > 0) {
                    const totalToPay = Math.min(totalAmount, amountToPay);
                    totalAmount = Math.max(0, totalAmount - totalToPay);
                    this.selectedInstallments.push({
                      ...installment,
                      amount_e2: amountToPay,
                      is_new: true,
                      paid_amount_e2: totalToPay
                    });
                  }
              });
          }
          else {
            this.periodFee.fee_installments
              .filter(installment => installment.paid_amount_e2 < installment.amount_e2)
              .forEach(installment => {
                const amountPaid = installment.paid_amount_e2;
                const amountToPay = installment.is_late
                  ? installment.amount_e2 + installment.late_extra_amount_e2 - amountPaid 
                  : installment.amount_e2 - amountPaid;
                this.selectedInstallments.push(
                  {
                    ...installment,
                    amount_e2: amountToPay,
                    is_new: true,
                    paid_amount_e2: amountToPay
                  }
                );
              });
          }
          this.paymentStep++
        } 
      } else {
        this.storePayment()
      }
    },
    shouldConfirmButtonDisabled() {
      switch (this.paymentStep) {
        case 1:
          return !this.payment.period_id || !this.payment.student_id || this.loadings.loadingStudents;
        case 2: {
          if(!this.periodFee) return true;
          const keys = ['type', 'date'];
          if(this.payment.type !== "1"){
            keys.push('receipt_number');
          }
          if(this.paymentOption === "installment" && (!this.isUpdating ? (!this.validateFirstPayment() && !this.validateFullPayment()) : true)){
            keys.push('amount');
          }
          return keys.some($0 => !this.payment[$0] || this.payment[$0] === null || this.payment[$0] === '');
        }
        case 3:
          return this.loadings.sendingPayment || this.selectedInstallments.length === 0;
        default:
          return true;
      }
    },
    handleFileSelection(event) {
      this.course.scheduled_content_resource = event.target.files[0]
      this.removeError(event.target.id)
    },
    getUnpaidFeeInstallments (installments) {
      return installments.filter(installment => installment.paid_amount_e2 < installment.amount_e2);
    },
    getMissingInstallmentsTotal (installment) {
      const amountPaid = installment.paid_amount_e2;
      const amountToPay = installment.is_late 
        ? installment.amount_e2 + installment.late_extra_amount_e2 - amountPaid 
        : installment.amount_e2 - amountPaid;
      return amountToPay;
    },
    getDaysUntilLateFee(installment) {
      if (installment) {
        const today = moment().startOf('day');
        const installmentDate = moment(installment.date).startOf('day');
        const diffInDays = installmentDate.diff(today, 'days');
        const dueDateWithGrace = installmentDate.clone().add(this.periodFee.installment_grace_period_days, 'days');
        const daysLeft = dueDateWithGrace.diff(today, 'days');
        const isSameDay = installmentDate.isSame(today, 'day');
        return {
          isAfter: isSameDay ? false : diffInDays <= 0,
          days: daysLeft
        };
      } return {
        isAfter: false,
        days: 0
      };
    },
    getInstallmentAmount(index){
      if(this.selectedInstallments[index]){
        return `${this.selectedInstallments[index].amount_e2 / 100}$`;
      }
      return this.periodFee.fee_installments[index].amount_string;
    },
    storePayment () {
      Vue.prototype.$confirm({
        message: `¿Desea${this.isUpdating ? ' actualizar' : ' reportar'} el pago?`,
        button: {
            no: 'No',
            yes: 'Si'
        },
        callback: confirm => {
          if (confirm) {
            let newPayment = { id: this.prevPayment.id };
            if (this.isUpdating) {
              Object.entries(this.payment).map(([key, value]) => {
                if(this.prevPayment[key] !== this.payment[key]){
                  newPayment = {
                    ...newPayment,
                    [key]: value
                  }
                }
              });
              if(newPayment.amount){
                newPayment.amount = newPayment.amount * 100;
              }
              newPayment.type = Number(newPayment.type);
              this.update({ ...newPayment });
            } else {
              let paymentAmount = this.payment.amount * 100;
              if(this.validateFirstPayment() || this.validateFullPayment()){
                paymentAmount = this.paymentOption === "installment" 
                  ? this.periodFee.initial_price 
                  : this.periodFee.initial_price + (this.periodFee.installments_price * this.periodFee.installments);
              }
              newPayment = {
                ...this.payment,
                amount: paymentAmount,
                type: Number(this.payment.type)
              }
              this.store(newPayment);
            }
          }
        }
      });
    },
    isEnabled(id) {
      const find = this.selectedInstallments.find(installment => installment.id === id);
      return find ? true : false;
    },
    validateFirstPayment(){
      if(this.periodFee?.payments){
        const filteredPayments = this.periodFee.payments.filter(payment => payment.status === 2);
        if(filteredPayments.length === 0){
          if(this.isUpdating){
            return (this.payment.amount / 100 === this.periodFee.initial_price);
          } return true;
        } return false;
      }
      return false;
    },
    validateFullPayment(){
      if(this.periodFee?.payments){
        const filteredPayments = this.periodFee.payments.filter(payment => payment.status === 2);
        if(filteredPayments.length === 0){
          if(this.isUpdating){
            const totalToPay = this.periodFee.fee_installments
              .reduce((acc, installment) => {
                acc += installment.amount_e2;
                return acc;
              }, 0);
            const amountPaid = this.payment.amount;
            return totalToPay / 100 === amountPaid - this.periodFee.initial_price;
          } return true;
        } return false;
      }
      return false;
    }
  },
  watch: {
    currentPaymentOnState(val) {
      this.course = {...val}
    },
    'payment.period_id'(val,prevVal){
      if(prevVal && prevVal !== val){
        this.loadings.loadingStudents = true;
        this.fetchStudents({ limit: 0, period: val, retired: 0 })
          .then(() => {
            this.payment.student_id = null;
            this.loadings.loadingStudents = false;
          });
      }
    },
    paymentOption(val){
      if(val === 'fully'){
        this.payment.amount = "";
        if(document.getElementById('amount')){
          document.getElementById('amount').value = "";
        }
      } else if (val === 'installment') {
        this.payment.amount = this.prevPayment.amount;
        if(document.getElementById('amount')){
          document.getElementById('amount').value = this.prevPayment.amount;
        }
      }
    }
  },
  created() {
    const id = this.$route.query.update
    this.setNavbarTitle(['Listado de materias', 'Crear materia'])
    if (id) {
      this.isUpdating = true;
      this.loadings.data = true;
      const found = this.payments.find(course => course.id === parseInt(id))
      if (found) {
        this.payment = { ...found }
        this.payment.amount = parseInt((this.payment.amount / 100).toFixed(0))
        this.prevPayment = { ...this.payment }
        this.setNavbarTitle(['Listado de pagos', found.title, 'Editar pago'])
        this.$repository.students
        .getStudentPeriodFee(this.payment.student_id)
        .then(({ data }) => {
          this.periodFee = data;
          this.payment.type = `${this.payment.type}`;
          this.paymentStep = 2;
          this.loadings.data = false;
        })
        .catch(() => {
          this.periodFee = null;
          this.paymentStep = 2;
          this.loadings.data = false;
        });
      } else {
        this.fetchCourse({
          id,
          query: { with: 'student' }
        })
        .then(() => {
          if(this.paymentState){
            this.payment = { ...this.paymentState }
            this.payment.amount = parseInt((this.paymentState.amount / 100).toFixed(0))
            this.prevPayment = { ...this.paymentState }
            this.setNavbarTitle(['Listado de pagos', this.paymentState.title, 'Editar pago'])
            this.$repository.students
            .getStudentPeriodFee(this.paymentState.student_id)
            .then(({ data }) => {
              this.periodFee = data;
              this.payment.type = `${this.payment.type}`;
              this.paymentStep = 2;
              this.loadings.data = false;
            })
            .catch(() => {
              this.periodFee = null;
              this.loadings.data = false;
            });
          }
        })
      }
    }else{
      this.fetchPeriods({ limit: 0 }).then(() =>{
        this.payment.period_id = this.periods[0].id;
        this.fetchStudents({ limit: 0, period: this.payment.period_id, retired: 0 });
      });
    }
  }
}
</script>
